module.exports = __webpack_public_path__ + "img/7.9cda04fa.jpg";